import { IconSettings } from '@tabler/icons-react'

export const PERMISSION_SETS_ACCOUNT_SETTINGS = {
  id: 'Account & Settings',
  description:
    'Grant access to view and edit organization and location settings.',
  icon: IconSettings,
  sections: [
    {
      title: 'permissions',
      permissions: [
        {
          type: 'checkbox',
          label: 'Manage organization profile',
        },
        {
          type: 'checkbox',
          label:
            'Manage location profiles and settings for their assigned locations',
        },
        {
          type: 'checkbox',
          label: 'Manage call log field options',
        },
        {
          type: 'checkbox',
          label: 'Manage incident field options',
        },
        {
          type: 'checkbox',
          label: 'Manage file categorization options',
        },
        {
          type: 'checkbox',
          label: 'Export data',
          info: 'Full access is required for this action.',
        },
      ],
    },
  ],
}
